import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Products", -1)
const _hoisted_2 = { class: "mx-1" }
const _hoisted_3 = { class: "mx-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_select_stores = _resolveComponent("select-stores")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_list = _resolveComponent("list")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, { onActionExport: _ctx.exportProductList }), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            "el-col": "",
            span: 24,
            class: "my-3 flex"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.title) = $event)),
                  placeholder: "Title"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.productType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.productType) = $event)),
                  placeholder: "Product type"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.personalized,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.personalized) = $event)),
                placeholder: "Type",
                clearable: "",
                onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClearPersonalized())),
                class: "mx-1"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { label: 'Personalize', value: true },
              { label: 'Regular', value: false },
            ], (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      placeholder: "Type",
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_select_stores, {
                modelValue: _ctx.params.store,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.store) = $event)),
                class: "mx-1"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_list, {
        documents: _ctx.documents,
        isLoading: _ctx.isLoading
      }, null, 8, ["documents", "isLoading"]),
      _createVNode(_component_pagination, {
        total: _ctx.total,
        pagination: _ctx.params.page,
        "onUpdate:pagination": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.params.page) = $event)),
        limit: _ctx.params.limit,
        "onUpdate:limit": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.params.limit) = $event))
      }, null, 8, ["total", "pagination", "limit"])
    ]),
    _: 1
  }, 16, ["onActionExport"]))
}